import { Reducer, Slice } from '@reduxjs/toolkit'

export type CreateReducer<State> = (
  sliceName: string,
  initialState?: Partial<State>,
) => Reducer<State>

export const reduceSlices = (slices: Slice[]) =>
  slices.reduce(
    (res, slice) => ({
      ...res,
      [slice.name]: slice.reducer,
    }),
    {},
  )

export const createReducers = <S>(reducer: CreateReducer<S>, names: string[]) =>
  names.reduce(
    (acc, name) => ({
      ...acc,
      [name]: reducer(name),
    }),
    {},
  )
